import { style } from 'typestyle';

export const TREND_UP_COLOR = '#00FF00';
export const TREND_DOWN_COLOR = '#ff0001';
export const NO_TREND_COLOR = '#ffd931';

export const MAP_BUBBLE_MIN_SIZE = '1%';
export const MAP_BUBBLE_MAX_SIZE = '15%';

const geoTrendsContainer = style({
  $debugName: 'geoTrendsContainer',
  height: '100%',
});

const chartContainer = style({
  $debugName: 'geotrends-simple-chart',
  height: '100%',
  position: 'relative',
});

const dropDownMapChart = style({
  $debugName: 'geotrends-dropdown-map-chart',
  position: 'absolute',
  zIndex: 9,
  right: 10,
  top: 5,
});

export default {
  geoTrendsContainer,
  chartContainer,
  dropDownMapChart,
};
